import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';

export interface ValidateAccountTransferParams {
  clientId: string;
  managedAccountId: string;
  fromAccountId: string;
}

const validateAccountTransfer = async (params: ValidateAccountTransferParams) =>
  authFetch('/Consumer/AcatsTransfers/Validate', {
    method: 'POST',
    ...httpBodyOptions(params, true),
  });

export const useValidateAccountTransferMutation = () => {
  return useMutation(validateAccountTransfer);
};
